import React, { Fragment } from "react";
import TextField from "./TextField";
import Label from "./Label";

const NumberField = ({
  value,
  currency = false,
  leftComponent,
  ...restProps
}) => {
  const options = { style: "currency", currency: "USD" };
  const numberFormat = new Intl.NumberFormat("en-US", options);
  const regex = /,|[a-z]|[A-Z]|'|"/g;

  return (
    <TextField
      {...restProps}
      value={
        currency && value
          ? typeof value === "number"
            ? value.toFixed(2).toString()
            : value.toString()
          : (value !== null || value !== undefined) && value.toString()
      }
      keyboardType={currency ? null : "numeric"}
      onChangeText={text => {
        if (currency) {
          const textNumber = text.replace(regex, "");
          if (!isNaN(Number(textNumber))) {
            restProps.onChangeText(text);
          }
        } else {
          restProps.onChangeText(text);
        }
      }}
      onBlur={e => {
        if (currency) {
          restProps.onChangeText(
            numberFormat
              .format(value.toString().replace(regex, ""))
              .slice(1)
              .replace(regex, "")
          );
        }
        restProps.onBlur(e);
      }}
      leftComponent={
        <Fragment>
          {leftComponent}
          {/* TODO Review Style to get from theme. */}
          {currency && value ? (
            <Label
              style={{ alignSelf: "center", marginLeft: 10, marginRight: -10 }}
            >
              {"$ "}
            </Label>
          ) : null}
        </Fragment>
      }
    />
  );
};

export default NumberField;
